import { isAuthorized, lazyLoadView, piloteAndAuditor, setNavL2 } from '@/router/routing'
import type { Route, RouteConfig } from 'vue-router'

export const indicatorsRoutes: RouteConfig = {
  path: 'indicators',
  name: 'indicator',
  component: () => lazyLoadView(import('@/contexts/indicators/IndicatorsView.vue')),
  beforeEnter: setNavL2,
  meta: {
    page_title: 'Indicators',
    i18nTitle: 'dashboards.menu.indicators',
    icon: 'chart-line',
    is_authorized: (route: Route) => isAuthorized(route),
    requires_auth: true,
    requires_tenant: true,
    requires_role: piloteAndAuditor,
    doc_id: 'indicator',
    feature_id: 'DASHBOARDS',
  },
}
